// extracted by mini-css-extract-plugin
module.exports = {"teamMember":"TeamFormation_teamMember__a2IQQ"};